<template>
  <section>
    <ul class="filters-list">
      <li
      >
        <router-link
          :to="{
            name: 'allSendOuts',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveSendOuts',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>

      <li>
        <router-link
          :to="{
            name: 'CompleteSendOuts',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ArchiveSendouts',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'AutoSendoutFailed',
            query: this.$route.query,
          }"
        >
          AUTO SENDOUT FAILED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
